var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IdfSelect',{attrs:{"label":_vm.$t('ctx.discount.listing.status-filter-placeholder'),"placeholder":_vm.$t('ctx.discount.listing.status-filter-placeholder'),"items":_vm.options},model:{value:(_vm.periodStatus),callback:function ($$v) {_vm.periodStatus=$$v},expression:"periodStatus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }